import React, { useState,useEffect } from "react";
import { Container, Row, Col, Dropdown, Button } from "react-bootstrap";
import Layout from "../components/layout";
import HeaderTwo from "../components/header/header-two";
import StickyHeader from "../components/header/sticky-header";
import PageHeader from "../components/page-header";
import Footer from "../components/footer";
import about1 from "../assets/images/shapes/about-bag-1-1.png";
import about2 from "../assets/images/resources/about2.jpg";
import about3 from "../assets/images/resources/about3.jpg";

const GetInvolved = () => {
    const [currentUrl, setCurrentUrl] = useState("");

    useEffect(() => {
      if (typeof window !== "undefined") {
        setCurrentUrl(window.location.href);
      }
    }, []);
  
    const shareOptions = [
      {
        name: "Facebook",
        icon: "fab fa-facebook",
        url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
      },
      {
        name: "Twitter",
        icon: "fab fa-twitter",
        url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}`,
      },
      {
        name: "LinkedIn",
        icon: "fab fa-linkedin",
        url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}`,
      },
    ];
  
    const openShareLink = (url) => {
      window.open(url, "_blank");
    };
  
  return (
    <Layout pageTitle="Get Involved || Love Foundation International">
      <HeaderTwo />
      <StickyHeader />
      <PageHeader title="Get Involved" crumbTitle="Get Involved" />
      <>
      <div className="about-one pt-40 pb-10">
               <Container>
                     <Row>
                       <div className="about-one__award">
                         <img src={about1} alt="" />
                       </div>
                       <Col lg={6}>
                         <img src={about2} alt="" className="img-fluid" />
                       </Col>
                       <Col lg={6}>
                         <img src={about3} alt="" className="img-fluid" />
                       </Col>
                     </Row>
                   </Container>
            </div>
        <section className="cause-details blog-details pt-120 pb-40" style={{ width: '100%', padding: '10% 10%' }}>
          <div className="cause-details__content">
          
            <h3>How to Participate in Love Foundation International</h3>
            <p>The world is full of people in desperate need—children without food, families without shelter, the sick without 
              medical care, and students whose dreams are hindered by poverty. At <b>Love Foundation International (LFI)</b>, 
              our mission is simple but urgent: to reach out in love to the downtrodden, less privileged, orphaned, poor, and 
              sick, giving them hope and a chance for a better life. Since our founding in <b>January 2010</b>, we have been tirelessly 
              working across <b>Nigeria and America</b>, touching lives one person at a time. But the work ahead is massive, and we 
              need <b>you</b> to help us make an even greater impact.
               </p>
               <br/>

               <p>Each year, LFI provides food and essential supplies to orphanages, ensuring that children without families still feel 
                the warmth of love. We visit hospitals, offering financial assistance to the critically ill who cannot afford treatment. 
                We extend our hands to <b>blind centers</b> in remote Nigerian cities and *leper colonies*, bringing relief to those abandoned 
                by society. Through our <b>Pen of Hope project</b>, we invest in education, ensuring that indigent students receive the quality 
                schooling they deserve. <b>But there is still so much more to be done!</b>
               </p>
<br/><br/>
            <h4>Donation Participation</h4>
            <p>
            You can become one of our donors (Our donors help us in funding our numerous projects and you can be a part: either one-time donation, weekly, bi-weekly, or monthly)
            <li><b>Choose a Cause:</b> Select the area you’re passionate about, such as education, healthcare, or disaster relief.</li>
            <li><b>Make a Donation:</b> Use our secure online platform to contribute. You can choose a one-time donation or set up a recurring contribution.</li>
            <li><b>See the Impact:</b> Stay updated with reports and stories that show how your donations are transforming lives.</li>

            </p>
            <br/>
            <h4>Partnership Opportunities</h4>
            <p>
            Collaborate with us as a dependable partner to expand the reach of our mission
      

            <li><b>Individual/Family Partners: </b> As an individual or family you can partner with us by committing to a weekly,
             bi-weekly, monthly etc. donations, we also depend on our partners on major projects that requires funding.</li>
            <li><b>Corporate Partnerships: </b> Companies can partner with us for CSR initiatives or to fund specific projects.</li>
            <li><b>Community Collaborations:</b> Join hands with us to organize local charity drives, events, or awareness campaigns.</li>
            <li><b>Advocacy Partner: </b> Help us promote our causes by spreading awareness and engaging others in our initiatives.</li>

            </p>
            <br/>
            <h4>Steps to Get Involved</h4>
            <p>
            <li><b>Visit Our Website </b>Explore donation and partnership options.</li>
            <li><b>Contact Us:</b>Reach out via email or our contact form to discuss partnership opportunities.</li>
            <li><b>Become a Partner:</b>by committing to give weekly, monthly, or quarterly. Our partners are the backbone of our mission, ensuring that we continue this great work.</li>
            <li><b>Join as a Volunteer: </b> if you are in Nigeria or America and want to give your time and skills to help us reach more lives.</li>
            </p>

            <p>
            By participating, you play a vital role in creating positive change and empowering communities. 
            <br/>
            The world becomes a better place when <b>compassion meets action</b>. We appreciate your time and heart for this cause. Together, we can bring <b>love in deeds</b> to those who need it the most. Join us today!
            </p>
            <div className="cause-card__bottom">
              <a href="/donate" className="thm-btn dynamic-radius">
                Donate Now
              </a>
              <Dropdown>
                <Dropdown.Toggle variant="secondary" className="cause-card__share">
                  <i className="azino-icon-share"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {shareOptions.map((option) => (
                    <Dropdown.Item
                      key={option.name}
                      onClick={() => openShareLink(option.url)}
                    >
                      <i className={option.icon}></i> {option.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {/* <div className="cause-details__presentations">
              <i className="fa fa-file-pdf"></i>
              <h3>Our Presentation</h3>
              <a href="#none" className="thm-btn dynamic-radius">
                Download
              </a>
            </div> */}
          </div>
        </section>
      </>
      <Footer />
    </Layout>
  );
};

export default GetInvolved;
